import { ColorScheme, ControlPosition, Map, MapControl, useApiIsLoaded, useMap } from '@vis.gl/react-google-maps';
import React, { useCallback, useEffect, useState } from 'react';
import { MarkerWithInfoWindow } from './MarkerWithInfoWindow';
import { CENTER, LOCATIONS, MAX_ZOOM } from './constants';
import { useLocation } from 'react-router-dom';

// https://www.google.com/maps/d/u/0/edit?mid=1LPBX23CwNxL1VbkkGyQSAlTr0-6jbdI&usp=sharing
export const LocationsMap = ({ locationIndex = -1 }) => {
    const map = useMap('mainMap');
    const apiIsLoaded = useApiIsLoaded();
    const [selectedElement, setSelectedElement] = useState(null);
    const [selectedLocationIndex, setSelectedLocationIndex] = useState(locationIndex);

    // const locationsForMarkers = location ? [location] : LOCATIONS;
    const locationsForMarkers = LOCATIONS;
    const handleBoundsChange = useCallback((ev) => {
        // console.log('bounds changed: ', ev.detail);
        if (map.getZoom() > MAX_ZOOM) {
            map.setZoom(MAX_ZOOM);
        }
    }, [map]);

    const fitToMarkers = useCallback(() => {
        if (!apiIsLoaded) return;
        if (!map) return;

        const bounds = new window.google.maps.LatLngBounds();
        for (const marker of locationsForMarkers) {
            bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
        }
        map.fitBounds(bounds);
    }, [map, apiIsLoaded, locationsForMarkers]);

    const routeLocation = useLocation();
    useEffect(() => {
        if (!apiIsLoaded) return;
        if (!map) return;

        /*fitToMarkers();

        // Are we focused on a single location?
        if (locationIndex !== -1) {
            map.panTo(new window.google.maps.LatLng(LOCATIONS[locationIndex].lat, LOCATIONS[locationIndex].lng)); // or setCenter
            // Wait for pan to finish, then zoom.  Doesn't work as expected, zoom is off center
            // const idleListener = map.addListener('idle', () => {
            //     window.google.maps.event.removeListener(idleListener);
            //     map.setZoom(MAX_ZOOM);
            // });
        }*/
    }, [map, apiIsLoaded, routeLocation, locationIndex, fitToMarkers]);

    useEffect(() => {
        if (!apiIsLoaded || !map) return;

        fitToMarkers();

        /*
        // Draw lines to each location
        const poly = new window.google.maps.Polyline({
            strokeColor: "#000000",
            strokeOpacity: 1.0,
            strokeWeight: 3,
        });
        poly.setMap(map);

        const path = poly.getPath();
        LOCATIONS.forEach((location) => {
            path.push(new window.google.maps.LatLng(location.lat, location.lng));
        });
         */
    }, [map, apiIsLoaded, fitToMarkers]);

    useEffect(() => {
        if (locationIndex !== -1) {
            setSelectedLocationIndex(locationIndex);
        }
    }, [locationIndex]);

    const markers = locationsForMarkers.map((locationForMarker, locIndex) => {
        const { lat, lng, title } = locationForMarker;
        const position = { lat, lng };

        // const showInfoWindow = location ? location.title === title : selectedElement === title;
        const showInfoWindow = selectedLocationIndex ? selectedLocationIndex === locIndex : selectedElement === title;

        return (
            <MarkerWithInfoWindow
                key={title}
                position={position}
                onClick={() => {
                    setSelectedElement(title);
                    setSelectedLocationIndex(locIndex);
                }}
                onClose={() => {
                    setSelectedElement(null);
                    setSelectedLocationIndex(-1);
                }}
                showInfoWindow={showInfoWindow}
                locationIndex={locIndex}
                {...locationForMarker}
            />
        );
    });

    // <iframe src="https://www.google.com/maps/d/embed?mid=1LPBX23CwNxL1VbkkGyQSAlTr0-6jbdI&ehbc=2E312F" width="100%" height="480" title="altMap"></iframe>

    return (
        <Map
            id="mainMap"
            mapId="386c6c8fe2013f0e"
            style={{ width: '100%', height: 'calc(100vh - 60px)' }}
            defaultCenter={CENTER}
            defaultZoom={12}
            gestureHandling={'cooperative'}
            disableDefaultUI={false}
            colorScheme={ColorScheme.LIGHT}
            controlSize={24}
            onBoundsChanged={handleBoundsChange}
        >
            {markers}
            <MapControl position={ControlPosition.LEFT_BOTTOM}>
                <img src="/img/WG_Signature_C_276x60.webp" alt="Woody Guthrie Logo" width="276" height="60"/>
            </MapControl>
        </Map>
    );
};
